import { createContext, useContext } from "react";

// Holds stable handler refs + isLegWise flag.
// Selection map intentionally NOT here — cells read from legSelectionStore
// via useSyncExternalStore for slice-level re-rendering.
export const LegSelectionContext = createContext({
  isLegWise: false,
  onLegToggle: () => {},      // (orderId, type, locationId) => void
  onRowToggle: () => {},      // (orderId, availableLegs) => void
  onHeaderToggle: () => {},   // (type, rowsWithLeg) => void
  getVisibleRowsWithLeg: () => [], // (type) => [{ orderId, locationId }]
  getVisibleOrders: () => [], // () => order[]
});

export const useLegSelection = () => useContext(LegSelectionContext);
